/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { publishProject as publishProjectService } from 'shared/services/publishProject';
import { showAlert } from 'shared/slices/admin/alert';
import { EAlert } from 'shared/types/alert';

/* istanbul ignore next */
export const publishProject = createAsyncThunk<Boolean, number, IThunkApi>(
  'projects/publish',
  async (id, { extra: context, dispatch, rejectWithValue }) => {
    try {
      const isUpdated = await publishProjectService(context, { id });

      if (isUpdated) {
        dispatch(showAlert({ message: 'Проект опубликован', type: EAlert.Info }));
      } else {
        dispatch(showAlert({ message: 'Проект не опубликован', type: EAlert.Error }));
      }

      return isUpdated;
    } catch (_) {
      dispatch(showAlert({ message: 'Проект не опубликован', type: EAlert.Error }));

      return rejectWithValue(false);
    }
  },
  {
    /**
     * Можно предотвратить вызов thunk-а через специальный объект с условием
     * (полезно, например, в случаях, если идет загрузка и надо предотвратить повторный запрос)
     */
    // condition: (params, _api) => {
    //   /**
    //    * В api есть стейт и extra
    //    *
    //    * сonst { getState, extra } = api;
    //    */
    //   const { getState } = _api;
    //   const {
    //     demo: { test },
    //   } = getState();
    //   return test;
    // },
  },
);
